<template>
  <div class="top-box">
    <LabelComponent :label_text="this.rawValues.view" label_type="headline/h2/bold 18"/>
    <LabelComponent :label_text="this.rawValues.content" label_type="headline/h2/bold 22"/>
  </div>
</template>

<script type="text/javascript">
import LabelComponent from '@/units/RichLabel.vue';


export default {
  components: {
    LabelComponent,
  },
  props: {
    fullSizable: {
      default: true,
    },
    maxChartWidth: {
      default: 350,
      required: false,
    },
    maxDiagramHeight: {
      default: 250,
      required: false,
    },
    isVertical: {
      default: true,
    },
    typeName: {
      default: 'gantt',
      required: false,
    },
    rawSeries: {
      default: null,
    },
    rawPoints: {
      default: null,
    },
    rawValues: {
      default: {},
    },
  },
  emits: {},
  computed: {
  },

};
</script>
<style>
.top-box {
    margin-top: 40px;
}
</style>
